"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DissolvedStatus = function DissolvedStatus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 0a12 12 0 1 0 12 12 12 12 0 0 0 -12-12z",
    fill: "#e4342a"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.28 7.94a.59.59 0 0 1 -.44-.19l-1.25-1.25a.62.62 0 0 1 .88-.88l1.25 1.25a.61.61 0 0 1 0 .88.59.59 0 0 1 -.44.19z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m10.2 7.26a.61.61 0 0 1 -.62-.62v-1.57a.61.61 0 0 1 .62-.62.64.64 0 0 1 .63.62v1.57a.64.64 0 0 1 -.63.62z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7.64 10.08h-1.56a.63.63 0 1 1 0-1.25h1.56a.63.63 0 0 1 0 1.25z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8 19.47a2.77 2.77 0 0 1 -2-.83l-.61-.64a2.83 2.83 0 0 1 0-4l2.13-2.13a.63.63 0 0 1 .88 0 .61.61 0 0 1 0 .88l-2.12 2.13a1.58 1.58 0 0 0 0 2.22l.66.66a1.56 1.56 0 0 0 2.21 0l2.13-2.13a.62.62 0 0 1 .88.88l-2.16 2.13a2.78 2.78 0 0 1 -2 .83z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.68 15.71h-2.79a.63.63 0 1 1 0-1.25h2.79a1.61 1.61 0 0 0 1.66-1.52v-1.25a1.69 1.69 0 0 0 -1.64-1.61h-2.81a.63.63 0 1 1 0-1.25h2.81a2.91 2.91 0 0 1 2.89 2.86v1.25a2.84 2.84 0 0 1 -2.91 2.77z"
  })));
};

var _default = DissolvedStatus;
exports["default"] = _default;